var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',{attrs:{"title":"Partners"},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('SellerList')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }